import { render, staticRenderFns } from "./index-old.vue?vue&type=template&id=442d55c8&scoped=true"
import script from "./index-old.vue?vue&type=script&lang=js"
export * from "./index-old.vue?vue&type=script&lang=js"
import style0 from "./index-old.vue?vue&type=style&index=0&id=442d55c8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442d55c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('442d55c8')) {
      api.createRecord('442d55c8', component.options)
    } else {
      api.reload('442d55c8', component.options)
    }
    module.hot.accept("./index-old.vue?vue&type=template&id=442d55c8&scoped=true", function () {
      api.rerender('442d55c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/index-old.vue"
export default component.exports